export const GERENCIALES_REPORT_TYPE = 'contract_details';

export const GERENCIALES_REPORT_OPTIONS = [
  {
    label: 'Detalle de contratos',
    value: GERENCIALES_REPORT_TYPE,
  },
];

export const CHART_COLORS = {
  feeType: ['#b71c1c', '#f9a825', '#8d6e63', '#ef6c00'],
  possession: ['#2e7d32', '#d32f2f'],
  clientType: ['#3949ab', '#d84315'],
  feeTypePossession: ['#1565c0', '#d84315', '#ffa000', '#2e7d32'],
  clientTypePossession: ['#d32f2f', '#ffa000', '#b71c1c', '#2e7d32'],
};
